import { type TableSelectedCell, useTableRows } from '@/components/custom/erp/input-table-v2';

export type SelectedCellInfo = TableSelectedCell;

export function useDetailRows<
  T extends {
    uuid: string;
    line?: number;
    dien_giai?: string;
  }
>(
  initialRows: T[] = [],
  onChange?: (rows: T[]) => void,
  onFieldValueChange?: (row: T, field: string, value: MuaHangRecord) => Partial<T>,
  dien_giai?: string
) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<T>({
    initialRows,
    defaultRows: 1,
    onChange,
    onFieldValueChange,
    defaultField: 'dien_giai'
  });

  const handleAddRow = () => {
    const newRow = {
      uuid: `temp-${Date.now()}`,
      dien_giai: dien_giai || '',
      ...(rows.length > 0 && rows[0].line !== undefined && { line: rows.length + 1 })
    } as unknown as T;

    const newRows = [...rows, newRow];
    setRows(newRows);
    onChange?.(newRows);
  };

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  };
}
